export { default as InsuranceCoverageStatusOverviewEmailEditTemplate } from './InsuranceCoverageStatusOverviewEmailEditTemplate';
